// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.default[data-v-414b1a1e]{\r\n\tcolor: var(--main-gray-5);\r\n\tfont-size: 12px;\n}\n.missing-mollie-module[data-v-414b1a1e] {\r\n\theight: 200px;\r\n\tbackground-color: var(--main-gray-2);\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
